import { Skeleton, TableCell, TableRow, Box } from "@mui/material";

export default function TableSkeleton({ cells }: { cells: string[] | number[] }) {
    return (
        <>
            <TableRow component="div">
                {cells.map((num) => (
                    <TableCell key={num} component="div">
                        <Skeleton height="50px" width="100%" />
                    </TableCell>
                ))}
                <TableCell component="div">
                    <Skeleton height="50px" width="100%" />
                </TableCell>
            </TableRow>
            <TableRow component="div">
                {cells.map((num) => (
                    <TableCell key={num} component="div">
                        <Skeleton height="50px" width="100%" />
                    </TableCell>
                ))}
                <TableCell component="div">
                    <Skeleton height="50px" width="100%" />
                </TableCell>
            </TableRow>
            <TableRow component="div">
                {cells.map((num) => (
                    <TableCell key={num} component="div">
                        <Skeleton height="50px" width="100%" />
                    </TableCell>
                ))}
                <TableCell component="div">
                    <Skeleton height="50px" width="100%" />
                </TableCell>
            </TableRow>
            <TableRow component="div">
                {cells.map((num) => (
                    <TableCell key={num} component="div">
                        <Skeleton height="50px" width="100%" />
                    </TableCell>
                ))}
                <TableCell component="div">
                    <Skeleton height="50px" width="100%" />
                </TableCell>
            </TableRow>
        </>
    );
}
